import React from 'react';
import { createFileRoute } from '@tanstack/react-router';

import { InvoicesDownloadPage } from '../../components/invoices/InvoicesDownloadPage/InvoicesDownloadPage';

export const Route = createFileRoute('/m/invoice-app-qr-code')({
  component: InvoicesDownloadRoute,
});

function InvoicesDownloadRoute() {
  return <InvoicesDownloadPage />;
}
